export default {
	logs: {
		log: "Log:",
		apps: "Applications",
		tasksAndInstruments: "Tasks and Tools",
		updates: "Updates",
		server: "Server:",
		app: "Application:",
		period: "Period:",
		periodNotSelect: "No period selected",
		refresh: "Refresh",
		lastSelected: "Last selection",
		reverseOrder: "Reverse order",
		savePeriod: "Save Period",
		withCoef: "With coefficient",
		lastSelectNotFound: "No previous selection found"
	},
	processes: {
		server: "Server:",
		stop: "Stop",
		view: "View",
		compact: "Optimal",
		full: "Full",
		saveFile: "Save file",
		autoRefresh: "Auto-refresh",
		thisActionStopProcessWantToContinue: "This action will stop this process. Do you want to continue?",
		attention: "Attention",
		cancel: "Cancel",
		sec: "sec",
		refresh: "Refresh"
	},
	services: {
		server: "Server:",
		start: "Start",
		restart: "Restart",
		stop: "Stop",
		willStart: "will start",
		willRestart: "will restart",
		willStop: "will stop",
		thisAction: "This is an action",
		thisServicesContinue: "these services. Do you want to continue?",
		thisServiceContinue: "this service. Do you want to continue?",
		attention: "Attention",
		cancel: "Cancel",
		operation: "Operation",
		completeSuccess: "completed successfully.",
		softSign: "",
		whenOperationPerforming: "When performing an operation",
		errorOccured: "An error has occurred.",
		diffStatusesOfServicesError: "Unable to perform bulk operation with services of different status",
	}
};
